import {ChangeDetectionStrategy, Component, computed, Input, signal} from '@angular/core';
import {NgForOf, NgIf} from "@angular/common";

@Component({
  selector: 'app-dot-animation',
  standalone: true,
  imports: [NgForOf, NgIf],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './dot-animation.component.html',
  styleUrls: ['./dot-animation.component.scss']
})
export class DotAnimationComponent {
  @Input() isLoading = false;
  @Input() set dotColors(colors: string[]) {
    this._colors.set(colors);
  }
  @Input() set animationSpeed(speed: number) {
    this._speed.set(speed);
  }
  
  private _colors = signal(['#1c8f42', '#58b368', '#33a36b']);
  protected _speed = signal(0.7);

  dots = computed(() =>
    this._colors().map((color, index) => ({
      color,
      delay: (index * this._speed()) / 4
    }))
  );

  trackByFn(index: number, dot: any) {
    return index;
  }
}
